<template>
  <div>
    <b-tabs pills>
      <b-tab title="Efetivo">
        <b-card-text>
          <TaxasParametrizadasItems :tipoCategoria="'Efetivo'" :generalData="generalData" />
        </b-card-text>
      </b-tab>
      <b-tab title="Estável">
        <b-card-text>
          <TaxasParametrizadasItems :tipoCategoria="'Estavel'" :generalData="generalData" />
        </b-card-text>
      </b-tab>
      <b-tab title="Pensionista">
        <b-card-text>
          <TaxasParametrizadasItems :tipoCategoria="'Pensionista'" :generalData="generalData" />
        </b-card-text>
      </b-tab>
      <b-tab title="Aposentado">
        <b-card-text>
          <template>
            <TaxasParametrizadasItems :tipoCategoria="'Aposentado'" :generalData="generalData" />
          </template>
        </b-card-text>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
  import TaxasParametrizadasItems from './Components/TaxasParametrizadasItems.vue'
  export default {
    components: {
      TaxasParametrizadasItems,
    },
    props: {
      generalData: {
        type: Object,
        default: () => {},
      },
    },

    mounted() {},
    data() {
      return {
        userData: this.$jwtDecode(localStorage.getItem('userData')).userData,
      }
    },
  }
</script>
